module.exports = __webpack_public_path__ + "static/media/menu_vert.fda44546.svg";